import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { downloadBlob } from "../lib/download";
import { FileText, History } from "lucide-react";

const inputCls = "px-3 py-2 bg-white border border-[var(--parchment-2)] focus:border-[var(--maroon)] outline-none text-sm";

export const RattrapagesBulletin = () => {
  const [classes, setClasses] = useState([]);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [classId, setClassId] = useState("");
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    api.get("/classes").then(({ data }) => setClasses(data.filter((c) => !c.id.startsWith("lvl:"))));
  }, []);

  const buildParams = () => {
    const params = {};
    if (start) params.start = start;
    if (end) params.end = end;
    if (classId) params.class_id = classId;
    return params;
  };

  const download = async () => {
    setBusy("bulletin");
    await downloadBlob("/rattrapages/bulletin.pdf", "bulletin-rattrapages.pdf", "Bulletin des rattrapages téléchargé", "Échec de la génération du bulletin", buildParams());
    setBusy(null);
  };

  const downloadRecidives = async () => {
    setBusy("recidives");
    await downloadBlob("/rattrapages/recidives.pdf", "bulletin-recidives-rattrapages.pdf", "Bulletin des récidives téléchargé", "Échec de la génération du bulletin des récidives", buildParams());
    setBusy(null);
  };

  return (
    <div className="mt-6 bg-white border border-[var(--parchment-2)] p-4 flex flex-wrap items-end gap-3" data-testid="rattrapages-bulletin">
      <div>
        <label className="eyebrow block mb-1">Du</label>
        <input type="date" className={inputCls} value={start} onChange={(e) => setStart(e.target.value)} data-testid="rattrapages-bulletin-start" />
      </div>
      <div>
        <label className="eyebrow block mb-1">Au</label>
        <input type="date" className={inputCls} value={end} onChange={(e) => setEnd(e.target.value)} data-testid="rattrapages-bulletin-end" />
      </div>
      <div>
        <label className="eyebrow block mb-1">Classe</label>
        <select className={inputCls} value={classId} onChange={(e) => setClassId(e.target.value)} data-testid="rattrapages-bulletin-class">
          <option value="">Toutes</option>
          {classes.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>
      <button
        className="btn-primary !py-2 !px-4 text-sm flex items-center gap-2 disabled:opacity-50"
        onClick={download}
        disabled={!!busy}
        data-testid="rattrapages-bulletin-btn"
      >
        <FileText size={15} /> {busy === "bulletin" ? "Génération..." : "Bulletin PDF des rattrapages"}
      </button>
      <button
        className="btn-secondary !py-2 !px-4 text-sm flex items-center gap-2 disabled:opacity-50"
        onClick={downloadRecidives}
        disabled={!!busy}
        title="Élèves convoqués 2 fois ou plus en rattrapage"
        data-testid="rattrapages-recidives-btn"
      >
        <History size={15} /> {busy === "recidives" ? "Génération..." : "Bulletin des récidives"}
      </button>
      <span className="text-xs text-[var(--muted)]">Sans dates : tous les rattrapages, groupés par mercredi. Récidives : élèves convoqués 2 fois ou plus.</span>
    </div>
  );
};
